'use client';

import {
  EnergyEfficiencyFlag,
  type EnergyEfficiencyFlagSpecificProps,
} from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import { useIntl } from 'react-intl';
import { efficiencyFlagMessages } from '../messages';

export const EnergyEfficiencyFlagLocalized = ({
  ...flagProps
}: EnergyEfficiencyFlagSpecificProps) => {
  const { formatMessage } = useIntl();
  return (
    <EnergyEfficiencyFlag
      {...flagProps}
      aria-label={formatMessage(efficiencyFlagMessages.energyEfficiency)}
    />
  );
};
